<template>
    <el-dialog class="preview_video_popup" :visible.sync="popupVisible" width="850px" :showClose="false">
        <video ref="video" class="video" :src="src" :poster="poster" autoplay controls v-if="src"></video>
    </el-dialog>
</template>

<script>
import popup from '@/mixins/popup';
export default {
    name: 'PreviewVideo',
    mixins: [popup],
    data(){
        return {
            src: '',
            poster: ''
        }
    },
    watch: {
        popupVisible(newValue){
            if(!newValue){
                this.pause();
            }
        }
    },
    methods: {
        init(){
            if(!this.data) return;
            this.src = this.data.src;
            this.poster = this.data.poster || '';
            this.$nextTick(this.play);
        },
        play(){
            console.log(this.$refs.video);
            this.$refs.video.play();
        },
        pause(){
            this.$refs.video.pause();
        }
    }
}
</script>

<style scoped>
    .preview_video_popup::v-deep .el-dialog{
        background: none;
        box-shadow: none;
    }
    .preview_video_popup::v-deep .el-dialog__header{
        display: none;
    }
    .preview_video_popup::v-deep .el-dialog__body{
        padding: 0;
    }
    .preview_video_popup .video{
        width: 850px;
        height: 478px;
    }

</style>